<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->
  <v-expansion-panel popout class="mt-4">
    <v-expansion-panel-header
      id="rec_crmnl_hstry"
      @click="onExpansionPanelClick"
      class="accent white-text text-body2 text-md-h6"
      >CRIMINAL HISTORY/EMBASSY LETTER REQUESTS
      <template v-slot:actions>
        <v-icon color="white" x-large> $expand </v-icon>
      </template></v-expansion-panel-header
    >
    <v-expansion-panel-content color="grey lighten-5">
      <div class="bcs-expansion-content mt-4">
        <v-card shaped>
          <v-card-title>
            <h4 class="howwrap">
              Disclaimer: The records database accessible to the Records Section
              of the Reno Police Department that would contain information
              between <br />1988-2001 is no longer available.
            </h4>
          </v-card-title>
        </v-card>
        <v-card shaped class="mt-4">
          <v-card-text>
            <div class="">
              <div class="text-body2 black--text">
                <b>Criminal History Requests</b> must be submitted on-line by
                clicking on this link:
              </div>
              <a
                href="https://www.reno.gov/government/departments/city-clerk/public-records"
                target="_blank"
                >CITY OF RENO PUBLIC RECORDS PORTAL.</a
              >
            </div>
            <div class="mt-1 text-body2 black--text">
              If you are obtaining a Criminal History for a person other than
              yourself, you will need to obtain a signed authorization, along
              with the listed personal identification, from that individual. If
              no signed authorization is received with your request you will
              only obtain Reno Police Department arrests resulting in a
              conviction in accordance with NRS 179A.
            </div>
          </v-card-text>
        </v-card>
        <v-card shaped class="mt-4">
          <v-card-text>
            <div>
              <div class="text-body2 black--text">
                <b>Embassy Letter Requests </b> must be submitted on-line by
                clicking on this link:
              </div>
              <a
                href="https://www.reno.gov/government/departments/city-clerk/public-records"
                target="_blank"
                >CITY OF RENO PUBLIC RECORDS PORTAL.</a
              >
            </div>
            <div class="text-body2 black--text">
              This service is provided to residents of Washoe County who are
              leaving the United States for employment, immigration purposes,
              etc..
            </div>
          </v-card-text>
        </v-card>
        <v-card shaped class="mt-4">
          <v-card-text>
            <div>
              <a
                href="https://renopd.com/formAdmin/content/pdfs_lib/FY23.24_FEE_SCHEDULE.pdf"
                target="_blank"
                >RECORDS FEE SCHEDULE.</a
              >
              The fee is $48.00, per above schedule.
            </div>
            <div class="text-body2 black--text">
              This service is provided to residents of Washoe County who are
              leaving the United States for employment, immigration purposes,
              etc..
            </div>
            <div class="text-body2 black--text">
              All Reno Police Department arrests with dispositions, if
              available, will be provided. If a disposition is unavailable, it
              is your responsibility to contact the Court of jurisdiction for
              the disposition. We do not contact the Court for you.
            </div>

            <div class="text-body2 black--text">
              IT IS YOUR RESPONSIBILITY TO CONTACT SPARKS POLICE DEPARTMENT,
              WASHOE COUNTY SHERIFF’S OFFICE AND THE NEVADA HIGHWAY PATROL TO
              ENSURE YOU ARE RECEIVING A COMPLETE CRIMINAL HISTORY IN WASHOE
              COUNTY.
            </div>
          </v-card-text>
        </v-card>
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<style lang="scss" scoped>
@import "../scss/site.scss";
.bcs-expansion-content {
  color: black;
}
b {
  font-weight: 800;
  color: black;
}
</style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "rec_crmnl_hstry",
  mixins: [bus_common],
  data: function () {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    onExpansionPanelClick(event) {
      this.$emit("onExpansionPanelClick", event);
    },
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
